import { Controller } from "@hotwired/stimulus"
import jQuery from "jquery"
import "select2"

// Ensure jQuery is available globally for Select2
window.$ = window.jQuery = jQuery

export default class extends Controller {
  static values = {
    modalId: String
  }

  connect() {
    this.initializeSelect2()
  }

  disconnect() {
    $(this.element).select2('destroy')
  }

  initializeSelect2() {
    // For Select2 inside Bootstrap modals, we need to set dropdownParent
    const modalElement = this.modalIdValue 
      ? document.getElementById(this.modalIdValue) 
      : this.element.closest('.modal')

    $(this.element).select2({
      theme: 'bootstrap-5',
      width: '100%',
      placeholder: $(this.element).data('placeholder') || 'Select an option',
      allowClear: true,
      selectionCssClass: 'select2--small',
      dropdownCssClass: 'select2--small',
      dropdownParent: modalElement ? $(modalElement) : undefined
    })
  }
}
